import module from 'recursoshumanos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class RecursoshumanosDirectorioComponent {
  contactos = null
  promise = false

  constructor (RecursosHumanosDirectorioService) {
    this.RecursosHumanosDirectorioService = RecursosHumanosDirectorioService
  }

  $onInit () {
    this.promise = this.RecursosHumanosDirectorioService.get()
      .then(({data}) => (this.contactos = orderBy(data, ['Importante'], ['desc']).map((item) => ({...item, agrupacion: item.importante ? '' : item.plaza}))))
  }
}

module.component('recursoshumanosDirectorio', {
  controller: RecursoshumanosDirectorioComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/directorio/component.js